import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useMemo } from 'react';
import { Box, Label, LabelText, LabelRequired, HintArea, Hint } from './form-field.styles.js';

var _LabelRequired, _div;

var _excluded = ["label", "hint", "disabled", "invalid", "children", "htmlFor", "hintId", "required", "hintPostfix", "hintGap"];
var FormField = function FormField(props) {
  var label = props.label,
      hint = props.hint,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$invalid = props.invalid,
      invalid = _props$invalid === void 0 ? false : _props$invalid,
      children = props.children,
      htmlFor = props.htmlFor,
      hintId = props.hintId,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      hintPostfix = props.hintPostfix,
      _props$hintGap = props.hintGap,
      hintGap = _props$hintGap === void 0 ? 4 : _props$hintGap,
      attrs = _objectWithoutPropertiesLoose(props, _excluded);

  var content = React__default.Children.map(React__default.Children.toArray(children), function (child) {
    if (! /*#__PURE__*/React__default.isValidElement(child)) {
      return null;
    }

    var chipProps = child.props;
    return /*#__PURE__*/React__default.cloneElement(child, _extends({}, chipProps, {
      invalid: invalid ? 'true' : undefined,
      disabled: disabled,
      required: required
    }));
  });
  var ariaHintAttrs = useMemo(function () {
    var arias = {};

    if (invalid) {
      arias['aria-live'] = 'polite';
    }

    return arias;
  }, [invalid]);
  return /*#__PURE__*/React__default.createElement(Box, attrs, label && /*#__PURE__*/React__default.createElement(Label, {
    required: required,
    disabled: disabled,
    htmlFor: htmlFor
  }, /*#__PURE__*/React__default.createElement(LabelText, null, label), required && (_LabelRequired || (_LabelRequired = /*#__PURE__*/React__default.createElement(LabelRequired, null, "*")))), content, /*#__PURE__*/React__default.createElement(HintArea, null, hint && /*#__PURE__*/React__default.createElement(Hint, _extends({}, ariaHintAttrs, {
    hintGap: hintGap,
    id: hintId,
    disabled: disabled,
    invalid: invalid
  }), hint), hintPostfix && !hint && (_div || (_div = /*#__PURE__*/React__default.createElement("div", null))), hintPostfix && hintPostfix));
};

export { FormField };
